import { StockEvents } from '../events';
import { VehicleDetailPage } from './detail/VehicleDetailPage';
import '../../image/404/32/car.svg';
import '../../image/404/32/van.svg';
import '../../image/404/32/tractor.svg';
import '../../image/404/43/car.svg';
import '../../image/404/43/van.svg';
import '../../image/404/43/tractor.svg';
import '../../image/404/169/car.svg';
import '../../image/404/169/van.svg';
import '../../image/404/169/tractor.svg';

const embedContainer = document.querySelector('[data-autowise-embed-container]')?.shadowRoot;

window.addEventListener(StockEvents.DETAIL_PAGE_LOADED, (e) => {
    new VehicleDetailPage(e.detail?.document || document).init();
});

if (!embedContainer) {
    window.dispatchEvent(new CustomEvent(StockEvents.DETAIL_PAGE_LOADED));
}
